module.exports = __webpack_public_path__ + "assets/img/title-d02d84a5.png";